import { IVariantType } from '~/modules/campaign/types';

import { CAMPAIGN_BACKGROUND_MAIN } from '~/constants/campaign';
import { Text } from '@shopify/polaris';

interface CampaignVariantItemProps {
  variantType: IVariantType;
  isSelected?: boolean;
  onClick?: () => void;
}

export const VARIANT_SELECTOR_MAPPING: Record<
  IVariantType,
  {
    name: string;
    color: string;
    description: string;
    backgroundColor: string;
  }
> = {
  [IVariantType.VARIANT_A]: {
    name: 'A',
    description: 'Control',
    color: CAMPAIGN_BACKGROUND_MAIN.ORIGIN as string,
    backgroundColor: '#D5E5FF',
  },
  [IVariantType.VARIANT_B]: {
    name: 'B',
    description: 'Variant',
    color: CAMPAIGN_BACKGROUND_MAIN.VARIANT as string,
    backgroundColor: '#F34A7033',
  },
};

export const CampaignVariantItem = ({
  variantType,
  isSelected = false,
  onClick,
}: CampaignVariantItemProps) => {
  return (
    <div
      className="px-3 inline-flex items-center gap-2 rounded-lg h-8 cursor-pointer"
      onClick={onClick}
      style={{
        backgroundColor: isSelected
          ? VARIANT_SELECTOR_MAPPING[variantType].backgroundColor
          : undefined,
      }}
    >
      <Text variant="bodyMd" fontWeight="semibold" as="span">
        <span style={{ color: VARIANT_SELECTOR_MAPPING[variantType].color }}>
          {VARIANT_SELECTOR_MAPPING[variantType].name}
        </span>{' '}
        <Text as="span" variant="bodySm" fontWeight="medium">
          {VARIANT_SELECTOR_MAPPING[variantType].description}
        </Text>
      </Text>
    </div>
  );
};
